import React from 'react';
import './PaymentMethodModal.css';
import { triggerHaptic } from '../services/telegram';
import { PAYMENT_METHODS } from '../utils/paymentMethod';
import sbpIcon from '../images/payment/sbp.svg';
import sberPayIcon from '../images/payment/sberpay.svg';
import { CardIcon, PaymentIconImg } from './PaymentIcons';

const METHOD_DESCRIPTIONS = {
  sbp: 'Оплата новым счётом СБП',
  sber_pay: 'Оплата новым SberPay',
  card: 'Оплата новой картой',
};

const METHOD_ICONS = {
  sbp: sbpIcon,
  sber_pay: sberPayIcon,
  card: null,
};

function PaymentMethodModal({ isOpen, currentMethod = 'card', onClose, onSelect }) {
  if (!isOpen) return null;

  const handleBackgroundClick = () => {
    triggerHaptic();
    onClose?.();
  };

  const handleCloseClick = (e) => {
    e.stopPropagation();
    triggerHaptic();
    onClose?.();
  };

  const handleSelect = (id) => {
    triggerHaptic();
    onSelect?.(id);
  };

  return (
    <div className="pm-overlay" onClick={handleBackgroundClick}>
      <div className="pm-modal" onClick={(e) => e.stopPropagation()}>
        <button
          type="button"
          className="pm-close"
          onClick={handleCloseClick}
          aria-label="Закрыть"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 6L6 18M6 6L18 18" stroke="white" strokeWidth="2" strokeLinecap="round" />
          </svg>
        </button>

        <h2 className="pm-title">Изменить способ оплаты</h2>

        <div className="pm-body">
          {PAYMENT_METHODS.map((method) => {
            const selected = currentMethod === method.id;
            const fullText = METHOD_DESCRIPTIONS[method.id] || method.label;
            const iconSrc = METHOD_ICONS[method.id];
            const isCard = method.id === 'card';

            return (
              <button
                key={method.id}
                type="button"
                className={`pm-method-row ${selected ? 'pm-method-row-selected' : ''}`}
                onClick={() => handleSelect(method.id)}
              >
                <div className="pm-method-left">
                  <div className="pm-method-icon">
                    {isCard ? (
                      <CardIcon className="pm-method-icon-img pm-method-icon-svg" />
                    ) : iconSrc ? (
                      <PaymentIconImg
                        src={iconSrc}
                        alt={fullText}
                        className="pm-method-icon-img"
                      />
                    ) : null}
                  </div>
                  <span className="pm-method-text">{fullText}</span>
                </div>
                {selected && (
                  <span className="pm-check" aria-hidden="true">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                      <g clipPath="url(#pm-check-clip)">
                        <path d="M9 1C7.41775 1 5.87103 1.46919 4.55544 2.34824C3.23985 3.22729 2.21447 4.47672 1.60897 5.93853C1.00347 7.40034 0.84504 9.00887 1.15372 10.5607C1.4624 12.1126 2.22433 13.538 3.34315 14.6569C4.46197 15.7757 5.88743 16.5376 7.43928 16.8463C8.99113 17.155 10.5997 16.9965 12.0615 16.391C13.5233 15.7855 14.7727 14.7602 15.6518 13.4446C16.5308 12.129 17 10.5823 17 9C17 6.87827 16.1571 4.84344 14.6569 3.34315C13.1566 1.84285 11.1217 1 9 1ZM14.225 6.315L7.655 12.88L3.775 9C3.6424 8.86739 3.5679 8.68754 3.5679 8.5C3.5679 8.31246 3.6424 8.13261 3.775 8C3.90761 7.86739 4.08747 7.79289 4.275 7.79289C4.46254 7.79289 4.6424 7.86739 4.775 8L7.665 10.89L13.235 5.325C13.3007 5.25934 13.3786 5.20725 13.4644 5.17172C13.5502 5.13618 13.6421 5.11789 13.735 5.11789C13.8279 5.11789 13.9198 5.13618 14.0056 5.17172C14.0914 5.20725 14.1693 5.25934 14.235 5.325C14.3007 5.39066 14.3527 5.46861 14.3883 5.5544C14.4238 5.64019 14.4421 5.73214 14.4421 5.825C14.4421 5.91786 14.4238 6.00981 14.3883 6.0956C14.3527 6.18139 14.3007 6.25934 14.235 6.325L14.225 6.315Z" fill="#60FFB0"/>
                      </g>
                      <defs>
                        <clipPath id="pm-check-clip">
                          <rect width="18" height="18" fill="white"/>
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                )}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default PaymentMethodModal;

